// @flow
import DetailsBudget from './DetailsBudget';

export default DetailsBudget;
